/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { transformPDFToView } from "dc-preview-utils/src/Utils/PageUtils";
import HyperlinkOverlay from "components/hyperlink/HyperlinkOverlay";
import { getPageHyperlinkRects } from "selectors/pageSelectors";
import { isInitialPageLoaded } from "selectors/pagedViewState";
import { HYPERLINK_RENDERING_PRIORITY } from "constants/constants";
import { pagesInView } from "selectors/pagedViewSelectors";

// currently getting rendered for high contrast mode only
function mapStoreToProps(stores, ownProps) {
  const pageIdx = ownProps.pageIndex;
  const pagesInViewObj = pagesInView(stores);
  const isPageInView = pageIdx >= pagesInViewObj.start && pageIdx <= pagesInViewObj.end;
  isInitialPageLoaded(stores) &&
    isPageInView &&
    stores.documentStore.loadAndGetPageHyperlinks(pageIdx, HYPERLINK_RENDERING_PRIORITY);
  const linkRects = getPageHyperlinkRects(stores, pageIdx);
  const linkDivs = [];
  linkRects &&
    linkRects.forEach(linkRect => {
      const viewCoordsMin = transformPDFToView(linkRect.xMin, linkRect.yMin, pageIdx, stores);
      const viewCoordsMax = transformPDFToView(linkRect.xMax, linkRect.yMax, pageIdx, stores);
      const top = Math.min(viewCoordsMin.y, viewCoordsMax.y);
      const bottom = Math.max(viewCoordsMin.y, viewCoordsMax.y);
      const left = Math.min(viewCoordsMin.x, viewCoordsMax.x);
      const right = Math.max(viewCoordsMin.x, viewCoordsMax.x);
      const linkDiv = { top, left, width: right - left, height: bottom - top, position: "absolute" };
      linkDivs.push(linkDiv);
    });

  return { linkDivs };
}

const HyperlinkOverlayContainer = inject(mapStoreToProps)(HyperlinkOverlay);
export { HyperlinkOverlayContainer };
